export const PAGE_LABELS = {
  TITLE: "AI Interviews - Diagnostics",
  CREATE_DIAGNOSTIC: "New Diagnostic",
  SEARCH_PLACEHOLDER: "Search diagnostics by name, client, or description...",
} as const;

export const DIALOG_LABELS = {
  CONFIRM_DELETE: "Delete",
  CANCEL: "Cancel",
} as const;

export const DELETE_DIALOG = {
  TITLE: "Delete Diagnostic",
  MESSAGE: "Are you sure you want to delete this diagnostic?",
} as const;

export const EMPTY_STATE_LABELS = {
  NO_DIAGNOSTICS: "No diagnostics yet. Create one to get started.",
  NO_SEARCH_RESULTS: "No results found. Try a different search term.",
} as const;

export const TABS = {
  MY_DIAGNOSTICS: "My Diagnostics",
  SHARED_WITH_ME: "Shared With Me",
  ADMIN: "Admin",
} as const;

export type TabValue = (typeof TABS)[keyof typeof TABS];

export const SORT_OPTIONS = {
  NAME_ASC: "name-asc",
  NAME_DESC: "name-desc",
  DATE_CREATED: "date-created",
  LAST_UPDATED: "last-updated",
} as const;

export const SORT_LABELS = {
  NAME_ASC: "Name (A-Z)",
  NAME_DESC: "Name (Z-A)",
  DATE_CREATED: "Date created",
  LAST_UPDATED: "Last updated",
} as const;

export type SortValue = (typeof SORT_OPTIONS)[keyof typeof SORT_OPTIONS];

export type CardViewTabValue = "my" | "shared" | "admin";
export type CardViewSortField = "name" | "updatedAt";

export const CARD_VIEW_SORT_FIELD_LABELS: Record<CardViewSortField, string> = {
  name: "Name",
  updatedAt: "Last Updated",
};
